export function validateListTagsWithError(htmlString: string): string | null {
  try {
    if (/<(\/?)list[^>]*[^>]>|<list$|<\/list$/.test(htmlString)) {
      return "Malformed <list> or </list> tag detected.";
    }

    const tagRegex = /<\/?list>/g;
    const stack: string[] = [];
    let match: RegExpExecArray | null;

    while ((match = tagRegex.exec(htmlString)) !== null) {
      const tag = match[0];
      if (tag === "<list>") {
        stack.push(tag);
      } else if (tag === "</list>") {
        if (stack.length === 0) {
          return "Unmatched </list> tag.";
        }
        stack.pop();
      }
    }

    if (stack.length > 0) {
      return "Unclosed <list> tag.";
    }

    return null;
  } catch (err: unknown) {
    return err instanceof Error ? err.message : "Unknown error";
  }
}
